import { Link } from "react-router-dom";
import Header from "../../../components/Header";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className={`w-full min-h-screen flex flex-col items-center md:justify-center relative`}
    >
      <div className={`md:absolute w-full top-0`}>
        <Header />
      </div>
      <div
        className={`myContainer flex max-md:flex-col-reverse justify-center items-center`}
      >
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center`}
        >
          <div className={`flex items-center gap-1 *:font-extrabold`}>
            <span className={`text-3xl md:text-5xl text-myGreen34`}>بازی</span>
            <span className={`text-3xl md:text-5xl text-myNeutral26 shrink-0`}>
              کن،
            </span>
            <span className={`text-3xl md:text-5xl text-myGreen34`}>رشد</span>
            <span className={`text-3xl md:text-5xl text-myNeutral26`}>کن</span>
          </div>
          <span
            className={`text-[#9E9E9E] text-lg md:text-2xl md:text-right max-md:tracking-tighter`}
          >
            زمــیــــــــــن رو نـــجـــات بـــــــــــــده
          </span>
          <div className={`flex flex-col gap-3 md:gap-5 mt-3 md:mt-7`}>
            <div
              className={`flex gap-6 md:gap-8 items-center w-full justify-center`}
            >
              <a href="#downloadSection">
                <button className="btn text-white bg-gradient-to-b from-[#0D9D69] to-[#69BC4D] border-none relative overflow-hidden">
                  دانلود اپلیکیشن
                  <img src="/img/home/Cafebazaar-Logo.png" alt="Bazaar logo" />
                  <div
                    className={`absolute -right-2 md:-right-4 -bottom-2 md:-bottom-4 bg-[#69BC4D] border-4 md:border-[5px] border-white rounded-[10px] size-6 md:size-8`}
                  ></div>
                </button>
              </a>
              <Link to={`https://app.gameandgrow.com`}>
                <button
                  className={`btn bg-white border-2 border-[#0D9D69] text-[#0D9D69]`}
                >
                  ورود به وب‌اپلیکیشن
                </button>
              </Link>
            </div>
            <div
              className={`flex gap-6 md:gap-9 items-center w-full justify-center`}
            >
              <Link to={`https://org.gameandgrow.com/`}>
                <button
                  className={`btn bg-white border-2 max-md:w-full border-myBlue text-myBlue`}
                >
                  ورود به پنل سازمـانی
                </button>
              </Link>
              <Link to={`https://ngo.gameandgrow.com/`}>
                <button
                  className={`btn bg-white border-2 max-md:w-full border-[#EA4335] text-[#EA4335]`}
                >
                  ورود ســـــــمن‌هــــا
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div
          className={`w-full md:w-1/2 flex justify-center items-center relative`}
        >
          <img
            className={`z-10`}
            src="/img/home/iPhone 15 Mockup, Perspective 1.png"
            alt="MockUp"
          />
          <img
            className={`absolute z-20`}
            src="/img/home/blurLines.png"
            alt="cover"
          />
          <img
            className={`absolute -bottom-10 -left-5`}
            src="/img/home/blurBg.png"
            alt="cover"
          />
        </div>
      </div>
    </section>
  );
}
